export default __webpack_public_path__ + "static/media/HOLIDAY_CHECK.22c58267.png";